import { useContextStrict } from 'hooks/useContextStrict';
import { IntlContext } from 'contexts/IntlContext';

export const useIntlDictionary = () => {
  const { dictionary } = useContextStrict(IntlContext);

  return dictionary;
};
